<template>
	<div class="app-container userIndex">
		<el-card>
			<div slot="header" class="clearfix">
				<h3 class="pageName">{{pageName}}</h3>
			</div>
			<el-button type="primary" icon="el-icon-plus" @click="handleAdd" class="mb20">新增文件</el-button>
			<el-form :model="queryParams" ref="queryForm" :inline="true" size="small" class="box_form">
				<el-form-item label="文件标题" prop="title">
					<el-input v-model="queryParams.title" placeholder="请输入文件标题" clearable
						@keyup.enter.native="handleQuery" @change="$forceUpdate()"></el-input>
				</el-form-item>
				<!-- <el-form-item label="所属赛事类型" prop="gameTypeId">
					<el-select v-model="queryParams.gameTypeId" placeholder="赛事类型" clearable filterable
						@change="$forceUpdate()">
						<el-option v-for="(item, index) in gameType" :key="index" :label="item.gameTypeName"
							:value="item.id" />
					</el-select>
				</el-form-item> -->
				<!-- <el-form-item label="所属赛事项目" prop="gameTypeId">
					<el-select v-model="queryParams.gameTypeId" placeholder="所属赛事项目" clearable filterable
						@change="$forceUpdate()">
						<el-option v-for="(item, index) in gameItem" :key="index" :label="item.itemName"
							:value="item.id" />
					</el-select>
				</el-form-item> -->
				<el-form-item label="模板分类" prop="fileTypeId">
					<el-select v-model="queryParams.fileTypeId" placeholder="模板分类" clearable filterable
						@change="$forceUpdate()">
						<el-option v-for="(item, index) in fileType" :key="index" :label="item.fileTypeName"
							:value="item.id" />
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
					<el-button icon="el-icon-refresh-left" @click="resetQuery">重置</el-button>
				</el-form-item>
			</el-form>

			<el-table v-loading="loading" element-loading-text="加载中" :data="list">
				<el-table-column label="序号" align="center" type="index" width="50" />
				<el-table-column label="文件标题" align="center" prop="title" />
				<el-table-column label="模板分类" align="center" prop="fileTypeName" />
				<!-- 	<el-table-column label="所属赛事类型" align="center" prop="gameTypeName" />
				<el-table-column label="所属赛事项目" align="center" prop="itemName" /> -->
				<el-table-column label="文件格式" align="center" prop="suffix"></el-table-column>
				<el-table-column label="文件大小" align="center" prop="fileSize" />
				<el-table-column label="启用/关闭" align="center" prop="isEnable" min-width="100">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.isEnable" active-value="1" inactive-value="0"
							@change="_switchEnable(scope.row)"> </el-switch>
					</template>
				</el-table-column>
				<el-table-column label="添加人" align="center" prop="createBy" />
				<el-table-column label="添加时间" align="center" prop="createTime"></el-table-column>
				<el-table-column label="操作" align="center" class-name="small-padding fixed-width">
					<template slot-scope="scope">
						<el-button size="small" plain type="primary" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="small" plain type="danger" @click="handleDel(scope.row)">删除</el-button>
						<el-button size="small" plain type="danger" @click="handleDownload(scope.row)">下载</el-button>
					</template>
				</el-table-column>
			</el-table>

			<pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="_getList" />

			<el-dialog :title="dialogTit" :visible.sync="dialogShow" width="600px" append-to-body>
				<el-form ref="setform" :model="setParams" size="mini" :rules="rules" label-width="120px">
					<!-- <el-form-item label="所属赛事类型:" prop="gameTypeId">
						<el-select v-model="setParams.gameTypeId" placeholder="全部" clearable style="width: 240px">
							<el-option v-for="(item, index) in gameType" :key="index" :label="item.gameTypeName"
								:value="item.id" />
						</el-select>
					</el-form-item>
					<el-form-item label="所属赛事项目:" prop="itemId">
						<el-select v-model="setParams.itemId" placeholder="全部" clearable style="width: 240px">
							<el-option v-for="(item, index) in gameItem" :key="index" :label="item.gameName"
								:value="item.id" />
						</el-select>
					</el-form-item> -->
					<el-form-item label="所属模板分类:" prop="fileTypeId">
						<el-select v-model="setParams.fileTypeId" placeholder="全部" clearable style="width: 240px">
							<el-option v-for="(item, index) in fileType" :key="index" :label="item.fileTypeName"
								:value="item.id" />
						</el-select>
					</el-form-item>
					<el-form-item label="文件标题:" prop="title">
						<el-input v-model="setParams.title" placeholder="请输入文件标题" clearable style="width: 240px" />
					</el-form-item>
					<el-form-item label="文件上传:" prop="filePath" class="small videoUpload">
						<div class="upload_box">
							<el-upload accept=".doc, .docx, .pdf" name="file" :multiple="multiple" :action="action"
								:headers="headers" :file-list="fileList" :on-success="handleChange"
								:beforeUpload="beforeUpload" :on-remove="handleRemove">
								<el-button type="primary" :loading="uploading">
									上传文件
								</el-button>
							</el-upload>
							<div class="upload_tip">提示：文件支持pdf，doc，docx上传</div>
						</div>
					</el-form-item>
					<el-form-item label="启用/关闭:" prop="isEnable">
						<el-switch v-model="setParams.isEnable" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="submitForm">确 定</el-button>
					<el-button @click="dialogShow = false">取 消</el-button>
				</div>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
	import * as API_File from "@/api/sportManage/file";
	import store from "@/store/index";
	export default {
		name: "userIndex",
		data() {
			return {
				pageName: '模版管理',
				types: [{
						value: '',
						name: "全部",
					},
					{
						value: '1',
						name: "线上赛事",
					},
					{
						value: '2',
						name: "线下赛事",
					},
				],
				queryParams: {
					keyWord: '',
					memberType: '',
					userStatus: '',
					pageNum: 1,
					pageSize: 10,
					sourceMemberMobile: '',
					time: [],
				},
				list: [],
				total: 0,
				loading: false,

				dialogShow: false,
				dialogTit: "添加模板文件",
				setParams: {
					isEnable: '1'
				},
				rules: {
					// gameTypeId: [{
					// 	required: true,
					// 	message: "请选择所属赛事类型",
					// 	trigger: "change"
					// }],
					// itemId: [{
					// 	required: true,
					// 	message: "请选择所属赛事项目",
					// 	trigger: "change"
					// }, ],
					fileTypeId: [{
						required: true,
						message: "请选择所属模板分类",
						trigger: "change"
					}, ],
					title: [{
						required: true,
						message: "请输入文件标题",
						trigger: "blur"
					}],
					filePath: [{
						required: true,
						message: "请上传文件",
						trigger: "change",
						validator: this.fileList,
					}],
					isEnable: [{ required: true }],
				},

				headers: {
					system: 1
				},
				multiple: false,
				uploading: false,
				file: null,
				fileList: [],
				actions: '',
				action: process.env.VUE_APP_BASE_API + "/api/file/uploadOss",
				headers: {
					system: 0,
					token: store.state.token,
				},
				gameType: [],
				gameItem: [],
				fileType: []
			};
		},
		created() {
			this._getList();
			this._getFileType();
		},
		methods: {
			handleAdd() {
				this.setParams = {
					isEnable: '1'
				}
				this.actions = 'add'
				this.dialogShow = true
				this.fileList = []
			},
			handleQuery() {
				this.queryParams.pageNum = 1;
				this._getList();
			},
			resetQuery() {
				this.$refs["queryForm"].resetFields();
				this._getList();
			},
			refreshList() {
				this.resetQuery();
				this.dialogShow = false
				this.fileList = []
			},
			// 接口-用户列表
			_getList() {
				API_File.fileList(this.queryParams).then((res) => {
					this.total = res.data.total;
					this.list = res.data.list;
				}).catch((err) => {

				});
			},
			// 编辑用户
			handleEdit(row) {
				this.fileList = []
				this.actions = 'edit'
				this.dialogShow = true
				this.setParams = JSON.parse(JSON.stringify(row));
				console.log(row)
				if (this.setParams.filePath) {
					let arr = {}
					arr.name = row.fileName
					arr.filePath = row.filePath
					this.fileList.push(arr)
				}
			},

			// 模板文件下载
			handleDownload(e){
				console.log(e.filePath)
				window.open(e.filePath)
			},

			// 用户详情
			handleDtl(row) {
				console.log(row);
				this.$router.push({
					path: '/user/detail',
					query: {
						id: row.id,
					},
				})
			},
			submitForm() {
				console.log(this.setParams)
				this.$refs['setform'].validate((valid) => {
					if (valid) {
						this.actions == 'add' ? this._addFile() : this._editFile()
						this.refreshList()
					} else {
						console.log('error submit!!');
						this.$message({
							message: '填写数据不全或数据有误',
							type: 'error'
						});
						return false;
					}
				});
			},
			beforeUpload(file) {
				let isLt20M = file.size < 1024 * 1024 * 20;
				if (!isLt20M) {
					//将fileList中本次file文件删掉
					fileList.splice(fileList.indexOf(file), 1);
					this.$message.error('所选文件单个超过20M');
					return false;
				}
				let text = file.size
				if (text) {
					text = parseInt(text);
					if (text < 1024) {
						text = text + "B";
					} else if (text < 1024 * 1024) {
						text = (text / 1024).toFixed(2) + "KB";
					} else {
						text = (text / 1024 / 1024).toFixed(2) + "MB";
					}
				}
				this.setParams.fileSize = text
				this.setParams.fileName = file.name
				this.setParams.suffix = file.name.slice(file.name.lastIndexOf(".") + 1);
				this.setParams.fileType = 2
				return true
			},
			handleChange(info) {
				this.setParams.filePath = info.data.url
				// this.$refs["queryForm"].resetFields();
				this.$refs.queryForm.validateField(['filePath']);
			},
			//接口- 查询模板分类
			_getFileType() {
				API_File.fileTypeList(this.setParams).then((res) => {
					console.log(res.data)
					this.fileType = res.data
				})
			},

			//接口-新增文件
			_addFile() {
				API_File.addFile(this.setParams).then((res) => {
					this.$message({
						message: '添加成功',
						type: 'success'
					})
					this.refreshList()
				}).catch((err) => {})
			},
			// 接口-编辑文件
			_editFile() {
				API_File.editFile(this.setParams).then((res) => {
					console.log(res);
					this.$message({
						message: '编辑成功',
						type: 'success'
					})
					this.refreshList()
				}).catch((err) => {});
			},
			// 接口-启用/关闭
			_switchEnable(item) {
				API_File.switchType({
					id: item.id,
					isEnable: item.isEnable,
				}).then((res) => {
					this.$message({
						message: '编辑成功',
						type: 'success'
					})
					this.refreshList()
					console.log(res);
				});
			},
			//删除模板文件提示
			handleDel(row) {
				this.$confirm(`确定删除模板文件"${row.fileTypeName}"?`, "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this._delFile(row)
					})
					.catch(() => {});
			},
			//接口-删除模板文件
			_delFile(row) {
				API_File.delFile({
					id: row.id
				}).then((res) => {
					this.$message({
						message: "删除成功",
					});
					this.refreshList()
				})
			},
			handleRemove(file, fileList) {
				this.fileList = []
				this.setParams.fileSize = ''
				this.setParams.suffix = ''
				this.setParams.fileType = ''
				this.setParams.filePath = ''
				console.log(file, fileList);
			},
		},

	};
</script>

<style lang="scss">
	@import "../../../assets/styles/common.scss";

	.userIndex {
		padding: 40px 40px;
		color: #676a6c;
		font-size: 13px;
		font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
		overflow-x: hidden;

	}
</style>